import React from 'react'
import TextLink from 'LuxKit/TextLink'
import offerPageURL from 'lib/offer/offerPageURL'
import BodyText from 'LuxKit/Typography/BodyText'
import { isBedbankOffer } from 'lib/offer/offerTypes'

type OfferType = App.Offer | App.BedbankOffer | App.OfferSummary | App.BedbankOfferSummary

interface Props {
  offer: OfferType
  offerPage: boolean
  onFinePrint: () => void
}

function TaxAndFeesText({ offer, offerPage, onFinePrint }: Props) {
  if (offer.type === 'bedbank_hotel') {
    return (<BodyText variant="medium" as="p">
      The taxes are tax recovery charges paid to vendors (e.g., hotels); for details, please see our Terms of Use.
      Service fees are retained as compensation in servicing your booking and may include fees charged by vendors.
    </BodyText>)
  }

  return (
    <BodyText variant="medium">
      This charge includes estimated amounts the travel service provider pays for their taxes, and/or taxes that we pay, to taxing
      authorities on your booking (including but not limited to sales, occupancy, and value-added tax). This amount may also include
      any amounts charged to us for resort fees, cleaning fees, and other fees and/or a fee we, the website you booked on, retain as
      part of the compensation for our and/or their services, which varies based on factors such as location, the amount, and how
      you booked.
      {isBedbankOffer(offer) && <>
        For more details, please see the <TextLink weight="regular" size="medium" to={`${offerPageURL(offer)}#fine-print`} target="_blank">Terms and Conditions</TextLink>.
      </>}
      {!isBedbankOffer(offer) &&
        <>
          Please refer to the {offerPage ? <TextLink weight="regular" onClick={onFinePrint}>‘Fine Print’</TextLink> : <TextLink weight="regular" to={`${offerPageURL(offer)}#fine-print`}>‘Fine Print’ </TextLink>} for any additional costs payable directly to the property.
        </> }
    </BodyText>
  )
}

export default TaxAndFeesText
